import React from 'react';
import { UserIcon, ClockIcon, UsersIcon, MapPinIcon, CalendarIcon } from 'lucide-react';
const MatchInfo = () => {
  // Mock match information
  const matchInfo = {
    date: 'March 15, 2024',
    time: '7:30 PM ET',
    venue: 'Madison Square Garden',
    city: 'New York, NY',
    attendance: '19,812',
    duration: '2:14',
    referees: [{
      name: 'Marc Davis',
      position: 'Crew Chief'
    }, {
      name: 'Courtney Kirkland',
      position: 'Referee'
    }, {
      name: 'Justin Van Duyne',
      position: 'Umpire'
    }],
    broadcasters: {
      tv: ['ESPN', 'MSG Network', 'Spectrum SportsNet'],
      radio: ['ESPN Radio', 'WFAN', 'Lakers Radio Network']
    },
    series: {
      seasonSeries: 'Knicks lead 1-0',
      lastMeeting: 'November 7, 2023 - Knicks 114, Lakers 109'
    }
  };
  return <div className="bg-white rounded-lg shadow-md p-6" data-id="element-328" data-mp="1mgwyxj4nigzd">
      <h2 className="text-xl font-bold mb-6" data-id="element-329" data-mp="1mflxvr2lbnby">Match Information</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-330" data-mp="29401msk9qgrr">
        {/* Game Details */}
        <div data-id="element-331" data-mp="251v95x5k3q6p">
          <h3 className="text-lg font-semibold mb-4" data-id="element-332" data-mp="2536dby2wyzyc">Game Details</h3>
          <div className="space-y-4" data-id="element-333" data-mp="202s3qblnzhy7">
            <div className="flex items-start" data-id="element-334" data-mp="201qorw1j2bb7">
              <CalendarIcon className="w-5 h-5 text-gray-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-335" data-mp="1v3xlbarlzvem" />
              <div data-id="element-336" data-mp="1v6bch8j64ngw">
                <div className="font-medium" data-id="element-337" data-mp="1q4m5c3z2gty3">Date & Time</div>
                <div className="text-gray-600" data-id="element-338" data-mp="1q6ysqwnlfwij">
                  {matchInfo.date} • {matchInfo.time}
                </div>
              </div>
            </div>
            <div className="flex items-start" data-id="element-339" data-mp="1hdlstar43umy">
              <MapPinIcon className="w-5 h-5 text-gray-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-340" data-mp="1ha6a7xy8c3gs" />
              <div data-id="element-341" data-mp="1cbcwc4f16ag3">
                <div className="font-medium" data-id="element-342" data-mp="17ed0snft4q38">Venue</div>
                <div className="text-gray-600" data-id="element-343" data-mp="17duwr4mwl7kr">{matchInfo.venue}</div>
                <div className="text-gray-600" data-id="element-344" data-mp="12f03f8rb80me">{matchInfo.city}</div>
              </div>
            </div>
            <div className="flex items-start" data-id="element-345" data-mp="srea4uorxzpk">
              <UsersIcon className="w-5 h-5 text-gray-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-346" data-mp="stqsva2cwe3o" />
              <div data-id="element-347" data-mp="xs23hn0h6smy">
                <div className="font-medium" data-id="element-348" data-mp="xoe96ln7i276">Attendance</div>
                <div className="text-gray-600" data-id="element-349" data-mp="jsapvndvfe9h">{matchInfo.attendance}</div>
              </div>
            </div>
            <div className="flex items-start" data-id="element-350" data-mp="nsupcxlx2tys">
              <ClockIcon className="w-5 h-5 text-gray-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-351" data-mp="1bif5z9ullf4w" />
              <div data-id="element-352" data-mp="1gh8lt8xcxi88">
                <div className="font-medium" data-id="element-353" data-mp="1ghrxw90btcec">Game Duration</div>
                <div className="text-gray-600" data-id="element-354" data-mp="1gj2wzvittvz4">{matchInfo.duration}</div>
              </div>
            </div>
          </div>
          <h3 className="text-lg font-semibold mt-8 mb-4" data-id="element-355" data-mp="16r6wyex6jvs9">
            Series Information
          </h3>
          <div className="space-y-3 text-gray-700" data-id="element-356" data-mp="1ughr3dk0yrxf">
            <div data-id="element-357" data-mp="1ufq4gs8eo4ja">
              <span className="font-medium" data-id="element-358" data-mp="1uf6rlpxm46c4">Season Series:</span>{' '}
              {matchInfo.series.seasonSeries}
            </div>
            <div data-id="element-359" data-mp="3jxdd7dc5pfr9">
              <span className="font-medium" data-id="element-360" data-mp="3jwu50ocb65qf">Last Meeting:</span>{' '}
              {matchInfo.series.lastMeeting}
            </div>
          </div>
        </div>
        {/* Officials & Broadcast */}
        <div data-id="element-361" data-mp="3tmn4iqz6eueb">
          <h3 className="text-lg font-semibold mb-4" data-id="element-362" data-mp="3tnf2u9k5r68a">Officials</h3>
          <div className="space-y-3" data-id="element-363" data-mp="3ooln0ahef34y">
            {matchInfo.referees.map((referee, index) => <div key={index} className="flex items-center" data-id="element-364" data-mp="30yhkk6fy59fj" data-mpi={index}>
                <UserIcon className="w-5 h-5 text-gray-500 mr-3" data-id="element-365" data-mp="3113z4q198p79" />
                <div data-id="element-366" data-mp="2w1r4vk820fun">
                  <div className="font-medium" data-id="element-367" data-mp="2w2kdyruhjhfy">{referee.name}</div>
                  <div className="text-sm text-gray-600" data-id="element-368" data-mp="3ay8hsfvw62jb">
                    {referee.position}
                  </div>
                </div>
              </div>)}
          </div>
          <h3 className="text-lg font-semibold mt-8 mb-4" data-id="element-369" data-mp="q5wttysnft6a">
            Broadcast Information
          </h3>
          <div className="space-y-4" data-id="element-370" data-mp="l7d921psknfi">
            <div data-id="element-371" data-mp="lahl1l9i0ngq">
              <div className="font-medium mb-2" data-id="element-372" data-mp="2qwp0zdkcweam">Television</div>
              <div className="flex flex-wrap gap-2" data-id="element-373" data-mp="2qyi8ev2sn2jo">
                {matchInfo.broadcasters.tv.map((channel, index) => <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm" data-id="element-374" data-mp="2zxdd22q6w4kv" data-mpi={index}>
                    {channel}
                  </span>)}
              </div>
            </div>
            <div data-id="element-375" data-mp="39t6xe8a5h2d7">
              <div className="font-medium mb-2" data-id="element-376" data-mp="3eue4s68drzjc">Radio</div>
              <div className="flex flex-wrap gap-2" data-id="element-377" data-mp="3estcyodgaup6">
                {matchInfo.broadcasters.radio.map((station, index) => <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm" data-id="element-378" data-mp="3jngs3wmkecr3" data-mpi={index}>
                    {station}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default MatchInfo;